import script from "./WebsiteLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./WebsiteLayout.vue?vue&type=script&setup=true&lang=ts"

import "./WebsiteLayout.vue?vue&type=style&index=0&id=5d07b18e&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d07b18e"]])

export default __exports__